import { ABaseModel } from '@pperform/pp-data-mappers';
import { fetchSubParcel } from 'fetchers/subParcel.fetchers';

interface SubParcelParams {
  shipmentUuid: string;
  organizationId: number;
  destinationCarrierId?: number;
}

export class SubParcelItem extends ABaseModel {
  pk: number = undefined;

  trackingNumber = '';

  carrierId: number = undefined;
}

/**
 * Retrieves sub-parcel tracking number for destination carrier display.
 *
 * Logic: Find sub-parcel where:
 * - parent_id = parcel.id (implicit - all sub-parcels belong to the parent)
 * - carrier.id = destination_carrier.id (filtered by destinationCarrierId param)
 *
 * Returns null on error to gracefully fallback to parent tracking number.
 */
export const getSubParcel = async (
  params: SubParcelParams,
): Promise<SubParcelItem> => {
  try {
    const data = await fetchSubParcel({
      shipment_uuid: params.shipmentUuid,
      organization_id: params.organizationId,
    });

    const subParcels = data?.sub_parcels?.map((parcel) => {
      return SubParcelItem.fromApiData(parcel);
    });

    // Filter sub-parcels by destination carrier ID if provided
    let targetSubParcel: SubParcelItem | undefined;

    if (params.destinationCarrierId) {
      targetSubParcel = subParcels.find(
        (subParcel) => subParcel.carrierId === params.destinationCarrierId,
      );
    }

    // If no matching sub-parcel found, return empty data
    if (!targetSubParcel) {
      return SubParcelItem.create({});
    }

    return targetSubParcel;
  } catch (error) {
    return SubParcelItem.create({});
  }
};
